var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts-box"},[_c('div',{ref:"echartRef",staticClass:"charts"})])
}
var staticRenderFns = []

export { render, staticRenderFns }